import { render } from "./addQuestionnaire.vue?vue&type=template&id=a25923fe&scoped=true"
import script from "./addQuestionnaire.vue?vue&type=script&lang=js"
export * from "./addQuestionnaire.vue?vue&type=script&lang=js"

import "./addQuestionnaire.vue?vue&type=style&index=0&id=a25923fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25923fe"]])

export default __exports__